import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface FaqInterface {
  id: number;
  title: string;
  branding_id: number;
  questions: FaqQuestion[];
}

export interface FaqQuestion {
  id: number;
  question: string;
  answer: string;
}

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(private httpService: HttpClient) { }

  getFaqs(brandingId: number): Observable<FaqInterface[]> {
    return this.httpService.get<FaqInterface[]>(`/branding-profiles/${brandingId}/faqs`).pipe(
      map(faqs => faqs.map(faq => ({
        ...faq,
        questions: faq.questions.map(question => ({
          ...question,
          question: this.stripNbsp(question.question),
          answer: this.stripNbsp(question.answer),
        }))
      })))
    );
  }

  // The FAQ editor's rich-text content uses NBSP as a plain word separator,
  // which gives the browser no legitimate wrap points and forces paragraphs
  // to overflow their container (FE-293).
  private stripNbsp(value: string): string {
    const NBSP = String.fromCharCode(160);
    return value ? value.split(NBSP).join(' ').replace(/&nbsp;/g, ' ') : value;
  }
}
